// extracted by mini-css-extract-plugin
module.exports = {"SrLink":"SrLink--SrLink--1e9Mn","color-blue-300":"SrLink--color-blue-300--3hepj","highlightYellowFadeIn":"SrLink--highlightYellowFadeIn--6UZu0"};